import styled, { css } from "styled-components";

export const BUTTON_WIDTH = 260;
export const BUTTON_HEIGHT = 40;

const disabledStyles = css`
  background-color: #9bbaf5;
  cursor: not-allowed;
  box-shadow: none;
`;

export const SSOButton = styled.button`
  width: ${BUTTON_WIDTH}px;
  height: ${BUTTON_HEIGHT}px;
  display: inline-flex;
  align-items: center;
  justify-content: flex-start;
  gap: 12px;
  padding: 0 18px;
  border: none;
  border-radius: 6px;
  background-color: #1a73e8;
  color: #ffffff;
  font-weight: 600;
  font-size: 14px;
  letter-spacing: 0.01em;
  font-family: "Google Sans", Arial, sans-serif;
  cursor: pointer;
  transition: background-color 0.15s ease, transform 0.02s ease;
  box-shadow: 0 4px 10px rgba(17, 51, 105, 0.18);
  text-align: left;

  &:hover {
    background-color: #1665d8;
  }

  &:active {
    transform: translateY(1px);
  }

  &:disabled {
    ${disabledStyles};
  }
`;
